import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function NotFound({ 
  accent = "#115e32",
  pageTitle = "404 Not Found | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-white via-[#fffdf6] to-white text-center">
      <motion.h1
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
        className="text-8xl font-extrabold text-yellow-600"
      >
        404
      </motion.h1>

      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-4 text-2xl font-semibold text-gray-700"
      >
        Oops! Page Not Found
      </motion.h2>

      <p className="mt-2 text-gray-500 max-w-md">
        The page you’re looking for doesn’t exist or has been moved.
      </p>

      <Link
        to="/"
        className="mt-6 px-6 py-3 bg-yellow-600 text-white rounded-2xl shadow-md hover:bg-yellow-700 transition-all"
      >
        Go Back Home
      </Link>
    </div>
  );
}
